<template>
  <v-layout wrap>
    <v-flex xs12>
      <v-alert small dense outlined color="info"  class="kim-card py-1 px-2" :value="true">
        <small class="caption" v-html="title"></small>
      </v-alert>
    </v-flex>
    <v-flex xs6 pa-1>
      <v-card @click="selectedTemplate = 'simple'" flat :color="selectedTemplate === 'simple' ? 'primary' : 'default'" v-ripple class="picker text-center  ">
        <v-chip color="transparent" small class="mx-auto my-1">Simple</v-chip>
        <v-img eager :src="require('@/assets/img/attention/simple_attention.png')" contain />
      </v-card>
    </v-flex>
    <v-flex xs6 pa-1>
      <v-card  @click="selectedTemplate = 'advanced'" flat :color="selectedTemplate === 'advanced' ? 'primary' : 'default'" v-ripple class="picker text-center  ">
        <v-chip color="transparent" small class="mx-auto my-1">Avanzado</v-chip>
        <v-img eager :src="require('@/assets/img/attention/advanced_attention.png')" contain />
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>

import {debounce} from "@/utils/Common";
import {ApiUtils} from "@/utils/ApiUtils";
import {mapGetters, mapState} from "vuex";

export default {
  name: "AttentionTemplatePicker",
  props:{
    autoSave: {
      type: Boolean,
      default: false
    }
  },
  comments:{ },
  data(){
    return {
      firstLoad: true,
      selectedTemplate: '',
      saving: false
    }
  },
  mounted(){
    const vm = this
    vm.setDefaults()
  },
  methods:{
    setDefaults(){
      const vm = this
      vm.selectedTemplate = vm.default
      vm.firstLoad = false
      console.log('first load off')
    },
    debouncedSave: debounce(function(){
      this.save()
    }, 500),
    async save(){
      var vm = this
      vm.error = ''

      if(vm.saving || !vm.selectedTemplate || !vm.currentProvider) return
      const {id} = vm.currentProvider
      vm.saving = true
      const response = await ApiUtils.makePatch(`provider/${id}/settings/specialist`, null, {
        attention_template: vm.selectedTemplate
      })
      vm.saving = false

      if(!response.ok){
        const json = await response.json()
        vm.error = json.message || 'Ocurrió un error intentando guardar la configuración'
        return
      }

      vm.$emit('saved')
      await ApiUtils.fetchMe()
    }
  },
  computed:{
    ...mapState(['currentProvider']),
    ...mapGetters(['specialistSettings']),
    default(){
      const vm = this
      if(!vm.specialistSettings){
        return ''
      }

      return vm.specialistSettings.attention_template

    },
    title(){
      const vm = this

      if(!vm.selectedTemplate){
        return 'Aún no has seleccionado una plantilla'
      }

      if(vm.selectedTemplate === 'advanced'){
        return 'En tu ficha tendrás disponible un completo set de herramientas separadas por sección. ' +
            'Esta es la ficha mas eficiente, pero es mas compleja y no se recomienda para usuarios con poca experiencia en apps.'
      }

      return 'En tu ficha tendrás disponible un único campo de texto libre en donde podrás escribir todo lo que necesites. ' +
          'La <b>ficha simple</b> es menos sofisticada en la gestión de datos, pero es mas sencilla de utilizar.'

    }
  },
  watch:{
    selectedTemplate(){
      const vm = this
      if(!vm.firstLoad && vm.autoSave){
        vm.debouncedSave()
      }
    },
    default(){
      const vm = this
      vm.setDefaults()
    }
  }
}
</script>

<style scoped>
  .picker{
    cursor: pointer;
    border-radius: 8px;
    border: 2px solid #ccc;
    overflow: hidden;
  }
</style>
